/// THIS FILE IS AUTOGENERATED!!! DO NOT EDIT MANUALLY!!!
/// INSTEAD, USE A VITE PLUGIN OR RUN `php artisan bridge:generate:enumerations` COMMAND.

export const BillingDriver = {
  BANK_TRANSFER: 'BANK_TRANSFER',
  CASH_ON_DELIVERY: 'CASH_ON_DELIVERY',
  CUSTOMER_CREDIT: 'CUSTOMER_CREDIT',
  FREE_PAYMENT: 'FREE_PAYMENT',
  PAYU: 'PAYU',
  PRZELEWY24: 'PRZELEWY24',
  IMOJE: 'IMOJE',
  PAY_NOW: 'PAY_NOW',
  TPAY: 'TPAY',
  AXEPTA: 'AXEPTA',
  ZEN: 'ZEN',
  REVOLUT: 'REVOLUT',
} as const;

export type BillingDriver = typeof BillingDriver[keyof typeof BillingDriver];
